<app-organizer-shared-layout-dashboard class="organizer-messaging-page-contact">
  <div class="col-span-12 md:col-span-5 md:col-start-2">
    <a
      app-cta
      class="my-3"
      [leftIconType]="iconArrowLeftAlt"
      [variant]="backButtonVariant"
      [routerLink]="backLink | localize"
    >
      {{ 'organizer.messaging.contact.back' | translate }}
    </a>

    <div #talkjsContainer class="hidden h-0"></div>

    <app-section
      [title]="'organizer.messaging.contact.section.title' | translate"
      [description]="
        'organizer.messaging.contact.section.description' | translate
      "
    >
      <form [formGroup]="form" (ngSubmit)="submit()">
        <app-form-input-group
          [label]="
            'a11y.organizer.messaging.contact.form.message.label' | translate
          "
          [isHiddenLabel]="true"
          [errors]="messageErrors"
          errorKey="message"
        >
          <app-form-textarea
            #content
            formControlName="message"
            [placeholder]="
              'organizer.messaging.contact.form.message.placeholder' | translate
            "
            [required]="true"
          ></app-form-textarea>
        </app-form-input-group>

        <button
          app-vtmn-play-button
          type="submit"
          [type]="ctaButtonType.Submit"
          [disabled]="isSubmitDisabled ? true : null"
          [attr.data-disabled]="isSubmitDisabled ? true : null"
        >
          {{ 'organizer.messaging.contact.form.submit' | translate }}
        </button>
      </form>
    </app-section>
  </div>
</app-organizer-shared-layout-dashboard>
